import * as ProRegularSvgIcons from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { useSearchParams } from 'react-router-dom'
import { useLocale } from 'src/hooks/locale/locale'
import { useTranslatable } from 'src/hooks/locale/utils'
import { Section } from 'src/tailwind/components/Section'
import SuspenseWrapper from 'src/views/includes/SuspenseWrapper'
import GraduatesFilter from './GraduatesFilter'
import GraduatesResults from './GraduatesResults'
import { DEFAULT_PAGE, DEFAULT_PER_PAGE, formValuesToFilters, parseFormValues } from './query'

export default function AdministratorStatisticsGraduatesPage(): JSX.Element {
  const t = useTranslatable()

  return (
    <SuspenseWrapper title={t('statistics:graduates')}>
      <PageContent />
    </SuspenseWrapper>
  )
}

function PageContent(): JSX.Element {
  const t = useTranslatable()
  const locale = useLocale()
  const [searchParams] = useSearchParams()

  const filters = React.useMemo(() => formValuesToFilters(parseFormValues(searchParams)), [searchParams])
  const page = parseInt(searchParams.get('page') ?? DEFAULT_PAGE, 10)
  const perPage = parseInt(searchParams.get('perPage') ?? DEFAULT_PER_PAGE, 10)

  const breadcrumbsItems = [
    {
      page: `${t('statistics:statistics')} - ${t('statistics:graduates')}`,
      path: `/${locale}/administrator/statistics/graduates`,
    },
  ]

  return (
    <Section
      title={t('statistics:graduates')}
      breadcrubms={breadcrumbsItems}
      icon={<FontAwesomeIcon icon={ProRegularSvgIcons.faChartPieAlt} />}
    >
      <GraduatesFilter />
      <GraduatesResults filters={filters} page={page} perPage={perPage} />
    </Section>
  )
}
